import { render } from "./SDServices.vue?vue&type=template&id=f9132898"
import script from "./SDServices.vue?vue&type=script&lang=js"
export * from "./SDServices.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__